import {combineReducers, configureStore} from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

import {reset} from "./actions/resetActions";
import storage from "redux-persist/lib/storage";

import {authAction, authReducer} from "./slices/authSlice";
import {userReducer, userAction} from "./slices/usersSlice";
import schoolsReducer from "./slices/schoolsSlice";
import holidaysReducer from "./slices/holidaysSlice";
import attendanceReducer from "./slices/attendanceSlice";
import expensesReducer from "./slices/expenseSlice";
import {conReducer, conAction} from "./slices/configSlice";
import {honorariumReducer, honorariumAction} from "./slices/honorariumSlice";
import scholarshipReducer from "./slices/scholarshipSlice";
import accountsReducer from "./slices/accountsSlice";
import dashboardReducer from "./slices/dashboardSlice";
import notificationReducer from "./slices/notificationSlice";
import approvalRequestReducer, {
  approvalRequestAction,
} from "./slices/approvalRequestSlice";

const persistedReducer = combineReducers({
  auth: authReducer,
  users: userReducer,
  schools: schoolsReducer,
  holidays: holidaysReducer,
  attendance: attendanceReducer,
  expenses: expensesReducer,
  config: conReducer,
  honorarium: honorariumReducer,
  scholarship: scholarshipReducer,
  accounts: accountsReducer,
  dashboard: dashboardReducer,
  notifications: notificationReducer,
  approvalRequests: approvalRequestReducer,
});

const rootPersistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"],
  version: 1,
};

const persistedRootReducer = persistReducer(
  rootPersistConfig,
  persistedReducer
);

const store = configureStore({
  reducer: persistedRootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const persistor = persistStore(store);

export {
  store,
  persistor,
  reset,
  authAction,
  userAction,
  conAction,
  honorariumAction,
  approvalRequestAction,
};

export * from "./thunks/authThunks";
export * from "./thunks/userThunks";
export * from "./thunks/profileThunks";
export * from "./thunks/schoolThunks";
export * from "./thunks/holidayThunks";
export * from "./thunks/attendanceThunks";
export * from "./thunks/expenseThunks";
export * from "./thunks/honorariumThunks";
export * from "./thunks/scholarshipThunks";
export * from "./thunks/dashboardThunks";
export * from "./thunks/notificationThunks";
export * from "./thunks/approvalRequestThunks";
